export const todoListPageStyle = {
	wrapper: {
		background: 'var(--default-white)',
		borderRadius: '8px',
		padding: '12px 16px',
		boxShadow: 'var(--box-shadow--1)',
		minHeight: 'calc(100vh - 128px)',
		height: '100%',
	},

	description: {
		color: 'var(--neutral-300)',
		marginBottom: '24px',
	},

	tabs: {
		'.MuiTab-root': {
			width: '50%',
			maxWidth: 'initial',

			h6: {
				color: 'var(--neutral-300)',
			},

			'&:hover h6': {
				color: '3px solid var(--primary-500)',
			},
		},

		'&.MuiTabs-root .MuiTab-root.Mui-selected': {
			borderBottom: '3px solid var(--primary-500)',

			'&:hover': {
				borderBottom: '3px solid var(--primary-500)',
			},

			h6: {
				color: 'var(--primary-900)',
				paddingBottom: '-5PXpx',
			},
		},
	},

	badgeIcon: {
		backgroundColor: 'var(--error-500)',
		marginLeft: '8px',
		padding: '12px 12px',
		borderRadius: ' 50px',
	},
};
